export const ENV = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api',
  APP_NAME: process.env.REACT_APP_APP_NAME || 'Cashier — Vault Play',
  TURNSTILE_ENABLED: process.env.REACT_APP_TURNSTILE_ENABLED === 'true',
  TURNSTILE_SITE_KEY: process.env.REACT_APP_TURNSTILE_SITE_KEY || '',
} as const;
